<mf-row>
  <mf-field-select-multiple
    [label]="gridFilter.header"
    [(ngModel)]="value"
    [enumName]="gridFilter.enumName ?? ''"
    [enumNameModule]="gridFilter.enumNameModule"></mf-field-select-multiple>
</mf-row>
